import { ProductType } from '@/components/modules/Funnel/types/ProductType';
import { ApplicationType } from '@/config/types';

export const getProductType = (selectedProduct: ApplicationType | number): ProductType => {
  switch (selectedProduct) {
    case 0:
      return ProductType.ALL;

    case ApplicationType.ORDER:
    case ApplicationType.PAY_BY_LINK:
      return ProductType.ORDER;

    case ApplicationType.CREDIT_LINE:
    case ApplicationType.AUTO:
    case ApplicationType.CONSUMER_LOAN:
    default:
      return ProductType.LOAN;
  }
};
